// Ajustes de un negocio tal como se guardan en `estilo` (__FEATURES__) cada vez que el master cambia un módulo.
// Lo guardado ahí es TODO lo que se conserva: antes solo se listaban algunos módulos y al cambiar uno se perdían los demás
// (los módulos nuevos de crecimiento se «deshabilitaban» al activar el siguiente). Ahora se conservan todos los `feature_*` que el negocio ya tenga.
export const getAllBusinessFeatures = (biz, overrides = {}) => {
  if (!biz) return {};
  const guardados = Object.fromEntries(Object.entries(biz).filter(([k, v]) => k.startsWith('feature_') && typeof v === 'boolean'));
  return {
    ...guardados,
    feature_staff: biz.feature_staff !== undefined ? biz.feature_staff : false,
    feature_services: biz.feature_services !== undefined ? biz.feature_services : true,
    feature_appointments: biz.feature_appointments !== undefined ? biz.feature_appointments : false,
    feature_orders: biz.feature_orders !== undefined ? biz.feature_orders : false,
    feature_menu_media: biz.feature_menu_media !== undefined ? biz.feature_menu_media : true,
    feature_identidad_ia: biz.feature_identidad_ia !== undefined ? biz.feature_identidad_ia : true,
    feature_finanzas: biz.feature_finanzas !== undefined ? biz.feature_finanzas : true,
    feature_prospecting: biz.feature_prospecting !== undefined ? biz.feature_prospecting : false,
    feature_catalogo: biz.feature_catalogo !== undefined ? biz.feature_catalogo : false,
    feature_cotizaciones: biz.feature_cotizaciones !== undefined ? biz.feature_cotizaciones : false,
    bot_activo: biz.bot_activo !== undefined ? biz.bot_activo : true,
    menu_pdf_url: biz.menu_pdf_url || "",
    menu_link_url: biz.menu_link_url || "",
    menu_text_list: biz.menu_text_list || "",
    muted_phones: Array.isArray(biz.muted_phones) ? biz.muted_phones : [],
    muted_phones_metadata: biz.muted_phones_metadata || {},
    custom_instructions: biz.custom_instructions || "",
    ...overrides
  };
};
